import { experienceFlagsSlice } from './experienceFlags.slice';

export const EXPERIENCE_FLAGS_REDUCER_KEY = experienceFlagsSlice.name;
export const experienceFlagsReducer = experienceFlagsSlice.reducer;
